import { datadogLogs } from '@datadog/browser-logs';
import { environment } from './environment';

export function configureDatadog() {
    const clientToken = environment.REACT_APP_DATADOG_CLIENT_TOKEN();
    const env = environment.REACT_APP_ENV();
    const version = environment.REACT_APP_VERSION();
    const service = 'estimator-app';

    if (clientToken) {
        datadogLogs.init({
            env,
            version,
            clientToken,
            service,
            forwardErrorsToLogs: true,
            sampleRate: 100,
        });

        datadogLogs.setLoggerGlobalContext({
            env,
            version,
            service,
            team: 'unjust-mustard',
        });
    }
}
